import React from 'react';
import classNames from "classnames";

import { ContentCardClassic } from './partials/contentCardClassic';
import { ContentCardCaptionedImage } from './partials/contentCardCaptionedImage';
import { ContentCardBanner } from './partials/contentCardBanner';

import styles from './contentcards.module.scss';
import { useMemo } from 'react';

declare global {
  interface Window { braze: any; }
}

export type ContentCardExtras = {
	[key: string]: string;
};

export type ContentCard = {
	id: string,
	title?: string,
	description?: string,
	url: string,
	linkText?: string,
	imageUrl: string,
	extras: ContentCardExtras,
	aspectRatio?: number,
	expiresAt: string,
	cardType?: string,
};

export type EnvCardsFilterProp = {
	key: string,
	value: string,
};

const getCardType = (card) => {
  if (card?.cardType) return card.cardType;

  return '';
}

const filterExpiredCards = (cards: ContentCard[]) => {
  const result: ContentCard[] = [];
  if (cards.length === 0) return cards;
  [...cards].forEach((card) => {
    const expired = card.expiresAt && new Date(card.expiresAt) < new Date();
    if (!expired) {
      result.push(card);
    }
  });

  return result;
}

/* ------------------------------------------ */
/* Function that filters cards for different envs. Env set by keyvalue param.
Purpose: display card only for specific env by set appropriate content card type
(e.g. cards for Cityzens should display cityzens content cards) */
/* ------------------------------------------ */

function envCardsFilter(cards: ContentCard[], keyValuePairs) {
  const kvpKeys = keyValuePairs.map(kvp => kvp.key);
  const result = [...cards];
  result.map((card) => {
    if (card.extras && Object.keys(card.extras).length) {
      if (kvpKeys.some(e => Object.keys(card.extras).includes(e))) {
        if (card.extras['Type']) {
          card.cardType = card.extras['Type'];
        }
      }
    }
  });

  if(result.length) {
    logImpressions(result);
  }

  return result;
}

function logImpressions (cards: ContentCard[]) {
  if (window.braze) {
      console.log('::: Braze: logContentCardImpressions');
      window.braze.logContentCardImpressions(cards);
  }
};

export function Contentcards({ cards, keyValueParam }: {cards: ContentCard[] | [], keyValueParam: EnvCardsFilterProp[]}) {

const preparedData = useMemo(() => filterExpiredCards(envCardsFilter(cards, keyValueParam)), [cards]);

const handleClick = (card: ContentCard) => {
  if (window.braze) {
      console.log('::: Braze: logContentCardClick', card);
      window.braze.logContentCardClick(card);
      window.braze.requestImmediateDataFlush();
  }
};

return (
    <>
      {(preparedData.length > 0) && (
        <div className={ classNames(styles.contentCardsWrapper) }>
          {preparedData?.length && (
            preparedData.map((card, index) => {
              switch(getCardType(card)) {
                case 'Classic':
                return <ContentCardClassic key={`content-card-${index}`} data={card} onClick={() => { handleClick(card) }} />
                case 'Captioned':
                return <ContentCardCaptionedImage key={`content-card-${index}`} data={card} onClick={() => { handleClick(card) }} />
                case 'Banner': 
                return <ContentCardBanner key={`content-card-${index}`} data={card} onClick={() => { handleClick(card) }} />
                default: return <></>
              }
            })
          )}
        </div>
      )}
    </>
  );
}
